import apiClient from '../utils/apiClient';

class EmployeeService {
    // Get all employees for a restaurant
    async getEmployees(restaurantId) {
        const response = await apiClient.get(`/users?restaurant=${restaurantId}`);
        return response;
    }

    // Get single employee
    async getEmployee(restaurantId, employeeId) {
        const response = await apiClient.get(`/restaurants/${restaurantId}/employees/${employeeId}`);
        return response;
    }

    // Create new employee
    async createEmployee(restaurantId, employeeData) {
        const response = await apiClient.post('/users', {
            ...employeeData,
            associatedRestaurant: restaurantId,
        });
        return response;
    }

    // Verify employee OTP (activate user)
    async verifyEmployeeOTP(userId, otp) {
        const response = await apiClient.post(`/otp/verify/${userId}`, { otp });
        return response;
    }

    // Update user status (active/inactive)
    async updateUserStatus(userId, isActive) {
        const response = await apiClient.patch(`/users/${userId}`, { isActive });
        return response;
    }

    // Send OTP for an existing employee (reactivation flow)
    async sendEmployeeOTP(userId) {
        const response = await apiClient.post(`/otp/send/${userId}`, {});
        return response;
    }

    // Update employee
    async updateEmployee(restaurantId, employeeId, employeeData) {
        const response = await apiClient.put(`/restaurants/${restaurantId}/employees/${employeeId}`, employeeData);
        return response;
    }

    // Delete employee
    async deleteEmployee(restaurantId, employeeId) {
        const response = await apiClient.delete(`/restaurants/${restaurantId}/employees/${employeeId}`);
        return response;
    }

    // Update employee role
    async updateEmployeeRole(restaurantId, employeeId, role) {
        const response = await apiClient.patch(
            `/restaurants/${restaurantId}/employees/${employeeId}/role`,
            { role }
        );
        return response;
    }

    // Update employee status (active/inactive)
    async updateEmployeeStatus(restaurantId, employeeId, isActive) {
        const response = await apiClient.patch(
            `/restaurants/${restaurantId}/employees/${employeeId}/status`,
            { isActive }
        );
        return response;
    }

    // Get employee schedule
    async getEmployeeSchedule(restaurantId, employeeId, period = 'week') {
        const response = await apiClient.get(`/restaurants/${restaurantId}/employees/${employeeId}/schedule?period=${period}`);
        return response;
    }

    // Update employee schedule
    async updateEmployeeSchedule(restaurantId, employeeId, scheduleData) {
        const response = await apiClient.put(`/restaurants/${restaurantId}/employees/${employeeId}/schedule`, scheduleData);
        return response;
    }

    // Get employee performance
    async getEmployeePerformance(restaurantId, employeeId, period = 'month') {
        const response = await apiClient.get(`/restaurants/${restaurantId}/employees/${employeeId}/performance?period=${period}`);
        return response;
    }
}

const employeeService = new EmployeeService();
export default employeeService;
